export default __webpack_public_path__ + "static/media/q9_step2_4.091f064c.png";